<template>
  <v-tooltip top :disabled="!isAttribute">
    <v-card
      class="d-flex logo my-1"
      elevation="3"
      :height="height"
      :width="width"
      :max-width="maxCardWidth"
      :max-height="maxCardHeight"
      :class="{'selectedBusinessImage':businessImage.selected,'hide': corruptedImage}"
      @click="$emit('selectBusinessImage',businessImage)"
      slot="activator"
    >
      <v-image-wrapper
        :src="businessImage.url"
        class="businessImage"
        contain
        @error="handleError"
      />
    </v-card>
    <span v-if="isAttribute">By <a :href="businessImage.photographerLink"> {{ businessImage.photographerName }} </a></span>
  </v-tooltip>
</template>
<script>
import {
  VCard,
  VTooltip } from 'vuetify/lib';
import VImageWrapper from '../../../../../components/VImgWrapper/VImgWrapper.vue';
export default {
  props: {
    businessImage: {
      type: Object,
      require: true,
      default: null
    },
    height: {
      type: Number,
      require: false,
      default: 150
    },
    width: {
      type: Number,
      require: false,
      default: 150
    },
    isAttribute: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      corruptedImage: false
    }
  },
  computed: {
    maxCardHeight () {
      if(this.$vuetify.breakpoint.width < 360){
        return 110;
      }
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 135
        default: return 150
      }
    },
    maxCardWidth () {
      if(this.$vuetify.breakpoint.width < 360){
        return 110;
      }
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 135
        default: return 150
      }
    }
  },
  components: {
    VCard,
    VTooltip,
    VImageWrapper
  },
  methods: {
    handleError(){
      this.corruptedImage = true;
      var hideBusinessLogo = document.getElementsByClassName('hide');
      for(let i = 0; i < hideBusinessLogo.length;i++)
      {
        var parent = hideBusinessLogo[i].closest('.logo-preview')
        if (parent) {
          parent.style.display = 'none';
        }
      }
    }
  }
}
</script>
<style scoped>

.logo:hover {
  cursor: pointer;
}

.selectedBusinessImage{
  border: solid 2px var(--v-primary-base);
  background-color: var(--v-primary-variation-1-base);
}

.hide {
  display: none !important;
}
</style>